var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCarecreditLogo = function SvgCarecreditLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6581 16.365C31.3101 14.068 31.0851 6.277 28.1701 8.351C24.1011 11.238 19.9641 14.363 17.2831 15.982C13.1701 18.456 8.34805 20.594 4.82905 21.805C3.83805 22.151 3.64305 22.161 3.65705 22.342C3.66205 22.522 3.97005 22.542 4.82505 22.491C10.7181 22.137 17.6851 21.091 23.6871 18.997C26.4071 18.049 27.2961 17.543 28.6581 16.365",
    fill: "#00AA9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.07 26.329C34.54 24.382 36.47 16.859 32.684 18.294C27.388 20.305 20.235 22.026 16.86 22.659C11.175 23.719 5.14302 23.847 1.12302 23.687C0.558018 23.66 0.0780176 23.571 0.00601762 23.785C-0.0559824 23.97 0.330018 24.149 0.956018 24.445C5.76602 26.72 13.916 28.17 22.662 27.735C26.664 27.538 28.555 26.985 30.071 26.329",
    fill: "#006F60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4311 7.98C25.2671 4.194 21.9431 -1.563 20.7311 0.714C18.8911 4.169 15.3941 8.938 14.0671 10.76C11.9671 13.622 9.60908 16.43 7.55408 18.488C7.02908 19.012 6.68208 19.29 6.77508 19.422C6.87408 19.555 7.13908 19.432 7.69008 19.181C11.9901 17.22 16.6101 14.597 20.1891 11.692C22.3091 9.971 22.7811 9.322 23.4311 7.98",
    fill: "#7BC043"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCarecreditLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "carecredit_logo.7016f664077118c4ed68a5a46fde88f4.svg";